import React from 'react';
import PropTypes from 'prop-types';

type Props = {

    type?           : 'default' | 'text' | 'text-multiline'
    label?          : any

    className?      : string
    labelClass?     : string
    elementClass?   : string

    onDelete?       : callback

    children?       : any
}

// DEPRECATED - user Form FLEX

export default class FormRow extends React.Component<Props> {

    static propTypes = {
        type: PropTypes.oneOf(['default','text','text-multiline']),
        label: PropTypes.any,                       // string or component

        labelClass: PropTypes.string,
        elementClass: PropTypes.string,

        onDelete: PropTypes.func
    }

    render() {

        const elementClasses = Classes("f-element", this.props.elementClass, {
            'txt-36': this.props.type === 'text',
            'txt-multiline': this.props.type === 'text-multiline',
        })

        return (
            <div className={Classes("f-row", this.props.className)}>
                <div className={Classes("f-label", this.props.labelClass)}>{this.props.label}</div>
                <div className={elementClasses}>
                    {this.props.onDelete &&
                    <div className="ui5-field-with-delete-on-hover">
                        {this.props.children}
                        <div className="ui5-ico-trash red s-14" onClick={this.props.onDelete}/>
                    </div>}

                    {!this.props.onDelete && this.props.children}
                </div>
            </div>
        );
    }
}
